// extracted by mini-css-extract-plugin
module.exports = {"back":"Forbidden403_back__2lsNB","backBtn":"Forbidden403_backBtn__3Emje","icon":"Forbidden403_icon__3a7yn"};